import { gql } from '@lichtblick/apollo';

export const GET_ORDER = gql`
  query getWorkOrder_V1($workOrderId: Int!) {
    getWorkOrder_V1(input: { workOrderId: $workOrderId }) {
      error
      data {
        id
        name
        approvalState
        numberOfSubmitted
        numberOfResubmitted
        modifiedAtUtc
        eaasId
        address {
          id
          isReadOnly
          street
          number
          zipCode
          city
          state
          country
          coordinates {
            latitude
            longitude
          }
        }
        qualityManager {
          id
          eMail
          firstName
          lastName
        }
        projectManager {
          id
          eMail
          firstName
          lastName
        }
        product {
          id
          name
        }
        customers {
          id
          customer {
            id
            name
            firstName
            lastName
            mobilePhoneNumber
            phoneNumber
            eMail
          }
        }
      }
    }
  }
`;

export const GET_ORDERS = gql`
  query getWorkOrders_V1(
    $page: PageInput
    $orderBy: [SortDescriptionInput!]
    $status: [ApprovalState!]
    $hasSubmitted: Boolean
    $hasResubmitted: Boolean
    $startDateUtc: DateTime
    $endDateUtc: DateTime
    $qualityManagerId: Int
  ) {
    getWorkOrders_V1(
      input: {
        page: $page
        orderBy: $orderBy
        status: $status
        hasSubmitted: $hasSubmitted
        hasResubmitted: $hasResubmitted
        startDateUtc: $startDateUtc
        endDateUtc: $endDateUtc
        qualityManagerId: $qualityManagerId
        includeStatistics: true
      }
    ) {
      totalNumberOfSubmitted
      totalNumberOfResubmitted
      totalItems
      data {
        id
        qualityManager {
          id
          firstName
          lastName
        }
        numberOfResubmitted
        numberOfSubmitted
        modifiedAtUtc
        name
        approvalState
        teams {
          id
          name
        }
        product {
          id
          name
        }
      }
    }
  }
`;

export const PULL_ORDER_RESPONSIBILITY = gql`
  mutation PullWorkOrder_V1($input: PullWorkOrderInput!) {
    pullWorkOrder_V1(input: $input) {
      error
      data {
        id
        name
        approvalState
        numberOfSubmitted
        numberOfResubmitted
        modifiedAtUtc
      }
    }
  }
`;
